<template>
	<div class="right-nav-content">

		<div class="right-nav">
			<ul class="nav-list">
				<li v-for="(navItem,index) in navList">
					<div class="nav-item" @click="goNav(navItem.id)">{{navItem.name}}</div>
					<ul class="sub-nav-list">
						<li class="sub-nav-item" :class="{active: currId == subNavItem.id}" v-for="subNavItem in navItem.subcategorys" @click="goNav(subNavItem.id,subNavItem.parentId)">{{subNavItem.name}}</li>
					</ul>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	import Vue from 'vue';
	import { mapState } from 'vuex'


	export default {
		data(){
			return {
				currId: ''
			}
		},
		computed: mapState({
			navList: state => state.homeState.navList,
		}),
		mounted(){
			this.getNavList();
		},
		methods:{
			getNavList(){

				this.$store.dispatch('getNavList');
			},
			goNav(id,parentId){

				this.currId = id;
				this.$store.dispatch('getCategory');
				
				
				this.$emit('goNav')
				if(parentId){
					this.$router.replace({
			      		path: '/productList/'+id
			      	});
//					this.$router.go();
          			this.$emit('change',id,false)
				}else {
					this.$router.replace({
			      		path: '/productList/parentId/'+id
			      	});
//			      	this.$router.go();
          			this.$emit('change',id,true)
				}
			}
		}
	}
</script>

<style lang="scss">
	@import '../../../assets/css/mixin';
	.right-nav-wap {
		padding: pxToRem(110px) pxToRem(30px) pxToRem(110px) 0;
		display: inline-block;
		width: pxToRem(558px);
		height: 100%;
		background: rgba(255,255,255,.9);
		top: 50%;
	    right: 0;
	    bottom: auto;
	    left: auto;
	    -webkit-transform: translate3d(0,-50%,0);
	    transform: translate3d(0,-50%,0);
	    opacity: .96;

	    .icon-nav-group {
	    	margin: pxToRem(30px) 0;
	    	display: block;
	    	text-align: right;

	    	position: absolute;
		    top: 0;
		    right: pxToRem(30px);
	    }
	}

	.right-nav-content {
		padding: pxToRem(120px) 0;
		width: 100%;
		height: 100%;
		position: relative;
		// background-color: rgba(255,255,255,.9);

		// &:before {
		// 	content: '';
		//     position: absolute;
		//     width: 100%;
		//     height: 1.6rem;
		//     background: #fff;
		//     bottom: 1.6rem;
		//     box-shadow: 0 -20px 10px -5px rgba(238, 238, 238, 0.9) inset;
		//     z-index: 9;
		// }

		.right-nav {
			width: 100%;
			position: absolute;
			top: pxToRem(120px);
    		bottom: pxToRem(120px);
   			overflow: auto;

   			/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
			&::-webkit-scrollbar{
			    width: 3px;
			    height: 3px;
			    background-color: #fff;
			    display: inline-block;
			}
			/*定义滚动条的轨道，内阴影及圆角*/
			&::-webkit-scrollbar-track{
			    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
			    border-radius: 10px;
			    background-color: #f5f5f5;
			}
			/*定义滑块，内阴影及圆角*/
			&::-webkit-scrollbar-thumb{
			    /*width: 10px;*/
			    height: 10px;
			    border-radius: 10px;
			    -webkit-box-shadow: inset 0 0 6px #ccc;
			    background-color: #555;
			}


		}

		.nav-list {
			width: 100%;
			font-size: pxToRem(28px);
    		overflow: auto;

			li {
				.nav-item {
					padding: pxToRem(18px) 0 pxToRem(18px) pxToRem(140px);
					font-weight: bold;
					&:active {
						// color: #d4b675;
						font-weight: bold;
					}
				}

				&:last-of-type {
					.sub-nav-list {
						margin-bottom: 0;
					}
				}
			}

			
			.sub-nav-list {
				margin-bottom: pxToRem(45px);
				font-size: pxToRem(24px);
				li {
					padding: pxToRem(18px) 0 pxToRem(18px)  pxToRem(164px);
					&.active {
						font-weight: bold;
					}
				}
			}
		}
	}
	
</style>


// WEBPACK FOOTER //
// classifyNavList.vue?14f51ae7